/**
 * ScrollToTopLink Component
 * 
 * A wrapper around React Router's Link component that automatically scrolls
 * to the top of the page when clicked.
 * 
 * Features:
 * - Preserves all Link props and functionality
 * - Automatically scrolls to top on navigation
 * - Smooth scrolling behavior
 * - Can be used as a drop-in replacement for Link
 */

import React from 'react';
import { Link } from 'react-router-dom';

const ScrollToTopLink = ({ children, to, onClick, ...rest }) => {
  const handleClick = (e) => {
    // Scroll to top with smooth behavior
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
    
    // Call the original onClick if it exists
    if (onClick) {
      onClick(e);
    }
  };

  return (
    <Link
      to={to}
      onClick={handleClick}
      {...rest}
    >
      {children}
    </Link>
  );
};

export default ScrollToTopLink; 